import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";

export enum RELATED_EMAIL_TYPE {
  Invoice = 1,
  Vindication = 2,
  Payment = 3,
  Booking = 4,
  KsefInvoice = 5,
}

export const RELATED_EMAIL_TYPE_ADD_EDIT_EMAIL_ADDRESS = [
  {
    value: RELATED_EMAIL_TYPE.Invoice,
    text: filterCapitalize(i18n.t("invoice")),
  },
  {
    value: RELATED_EMAIL_TYPE.Vindication,
    text: filterCapitalize(i18n.t("vindication")),
  },
  {
    value: RELATED_EMAIL_TYPE.Payment,
    text: filterCapitalize(i18n.t("payment")),
  },
  {
    value: RELATED_EMAIL_TYPE.Booking,
    text: filterCapitalize(i18n.t("booking")),
  },
  {
    value: RELATED_EMAIL_TYPE.Invoice,
    text: filterCapitalize(i18n.t("invoiceKsef")),
  },
];
